import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"block","text-align":"center","font-size":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: _ctx.title,
    loading: _ctx.loading,
    visible: _ctx.visible,
    width: "600px",
    footer: null,
    "destroy-on-close": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_spin, { style: {"display":"block","font-size":"30px"} }),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.content), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "loading", "visible"]))
}